export default function ResumenElo({ partido, resultado, evaluacion, eloAntes, eloDespues, onFinalizar, guardando, soloEvaluar }) {

  const diferencia  = (eloDespues || 0) - (eloAntes || 0);
  const subio       = diferencia > 0;

  const evalValues = evaluacion?.evaluaciones
    ? Object.values(evaluacion.evaluaciones)
    : [evaluacion?.puntualidad, evaluacion?.fairplay, evaluacion?.ambiente, evaluacion?.organizacion].filter(Boolean);

  const promedioEval = evalValues.length > 0
    ? (evalValues.reduce((a, b) => a + b, 0) / evalValues.length).toFixed(1)
    : null;

  return (
    <div style={styles.wrap}>

      {/* Icono resultado — solo si no es soloEvaluar */}
      {!soloEvaluar && resultado && (
        <>
          <div style={styles.iconoWrap}>
            <div style={styles.icono}>
              {resultado.ganamos ? '🏆' : resultado.empate ? '🤝' : '😔'}
            </div>
            <div style={styles.resultadoTexto}>
              {resultado.ganamos ? '¡Victoria!' : resultado.empate ? 'Empate' : 'Derrota'}
            </div>
            <div style={styles.marcador}>
              {resultado.golesLocal} – {resultado.golesVisitante}
            </div>
            <div style={styles.rival}>vs {partido?.rival || 'Rival'}</div>
          </div>

          {/* ELO */}
          <div style={styles.eloCard}>
            <div style={styles.eloCardTitle}>Actualización de ELO</div>
            <div style={styles.eloRow}>
              <div style={styles.eloItem}>
                <div style={styles.eloItemNum}>{eloAntes}</div>
                <div style={styles.eloItemLabel}>ELO anterior</div>
              </div>
              <div style={styles.eloFlecha}>
                <div style={{ ...styles.eloDiferencia, color: subio ? '#16A34A' : '#EF4444' }}>
                  {subio ? '↑ +' + diferencia : '↓ ' + diferencia}
                </div>
              </div>
              <div style={styles.eloItem}>
                <div style={{ ...styles.eloItemNum, color: subio ? '#16A34A' : '#EF4444' }}>
                  {eloDespues}
                </div>
                <div style={styles.eloItemLabel}>Nuevo ELO</div>
              </div>
            </div>
            <div style={styles.eloExplicacion}>
              {resultado.ganamos
                ? 'Ganaste ELO por tu victoria.'
                : resultado.empate
                ? 'El empate ajustó levemente tu ELO.'
                : 'Perdiste ELO por la derrota. Sigue jugando para recuperarlo.'}
            </div>
          </div>
        </>
      )}

      {/* Si soloEvaluar, mostrar confirmación simple */}
      {soloEvaluar && (
        <div style={styles.iconoWrap}>
          <div style={styles.icono}>⭐</div>
          <div style={styles.resultadoTexto}>¡Evaluación enviada!</div>
          <div style={styles.rival}>vs {partido?.rival || 'Rival'}</div>
        </div>
      )}

      {/* Evaluación enviada */}
      {promedioEval && (
        <div style={styles.evalCard}>
          <div style={styles.evalTitle}>Tu evaluación enviada</div>
          <div style={styles.evalGrid}>
            {[
              { key: 'puntualidad', label: 'Puntualidad',   val: evaluacion?.evaluaciones?.puntualidad  || evaluacion?.puntualidad  },
              { key: 'fairplay',    label: 'Fair play',      val: evaluacion?.evaluaciones?.fairplay     || evaluacion?.fairplay     },
              { key: 'ambiente',    label: 'Buen ambiente',  val: evaluacion?.evaluaciones?.ambiente     || evaluacion?.ambiente     },
              { key: 'organizacion',label: 'Organización',   val: evaluacion?.evaluaciones?.organizacion || evaluacion?.organizacion },
            ].filter(e => e.val).map(({ key, label, val }) => (
              <div key={key} style={styles.evalItem}>
                <div style={styles.evalItemLabel}>{label}</div>
                <div style={styles.evalItemVal}>{val}.0</div>
              </div>
            ))}
          </div>
          {evaluacion?.comentario && (
            <div style={styles.comentario}>"{evaluacion.comentario}"</div>
          )}
          <div style={styles.evalPromedio}>
            Promedio enviado: <strong>{promedioEval}</strong>
          </div>
        </div>
      )}

      <div style={styles.notaRRSS}>
        🎉 ¡Comparte tu resultado en redes sociales!
        Tu tarjeta de partido está lista para Instagram y WhatsApp.
      </div>

      <button
        style={{
          ...styles.btnFinalizar,
          opacity: guardando ? 0.6 : 1,
          cursor: guardando ? 'not-allowed' : 'pointer',
        }}
        onClick={onFinalizar}
        disabled={guardando}
      >
        {guardando ? 'Guardando...' : 'Volver a Mis Partidos'}
      </button>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  iconoWrap: { textAlign: 'center', marginBottom: 24 },
  icono: { fontSize: 56, marginBottom: 8 },
  resultadoTexto: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  marcador: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 24, fontWeight: 700, color: '#4A5568', marginBottom: 4,
  },
  rival: { fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  eloCard: {
    background: '#0D1117', borderRadius: 16, padding: '20px', marginBottom: 16,
  },
  eloCardTitle: {
    fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 16, textAlign: 'center',
  },
  eloRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 },
  eloItem: { textAlign: 'center', flex: 1 },
  eloItemNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 36, fontWeight: 800, color: 'white', lineHeight: 1,
  },
  eloItemLabel: { fontSize: 11, color: 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif", marginTop: 4 },
  eloFlecha: { textAlign: 'center', flex: 0.5 },
  eloDiferencia: {
    fontFamily: "'Barlow Condensed', sans-serif", fontSize: 24, fontWeight: 800,
  },
  eloExplicacion: {
    fontSize: 12, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif", textAlign: 'center', lineHeight: 1.5,
  },
  evalCard: { background: '#F4F6FA', borderRadius: 14, padding: '16px', marginBottom: 16 },
  evalTitle: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700, color: '#141922', marginBottom: 12,
  },
  evalGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8, marginBottom: 10 },
  evalItem: {
    background: 'white', borderRadius: 8, padding: '8px 12px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  evalItemLabel: { fontSize: 12, color: '#4A5568', fontFamily: "'Barlow', sans-serif" },
  evalItemVal: {
    fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: '#FF6B1A',
  },
  comentario: {
    fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif",
    fontStyle: 'italic', marginBottom: 8, lineHeight: 1.4,
  },
  evalPromedio: { fontSize: 13, color: '#4A5568', fontFamily: "'Barlow', sans-serif", textAlign: 'right' },
  notaRRSS: {
    background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 12,
    padding: '12px 16px', fontSize: 13, color: '#92400E',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.5, marginBottom: 20, textAlign: 'center',
  },
  btnFinalizar: {
    width: '100%', padding: '14px', background: '#FF6B1A', border: 'none',
    borderRadius: 12, fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white',
  },
};
